export { default as NikoInventoryRequestEmailEditTemplate } from './NikoInventoryRequestEmailEditTemplate';
